import {Card} from "../../../../../../components/card/card.jsx";
import SentryRow from "../../../../../../components/template/sentry-row.jsx";
import InputForm from "../../../../../../components/input/input-form.jsx";
import {MaskDefault} from "../../../../../../utils/mask.js";
import {getCities, getNeighborhoods, getStreets} from "../../../../../../utils/location-utils.js";
import optionsUtils from "../../../../../../utils/options-utils.js";
import SelectComponent from "../../../../../../components/select/select-component.jsx";
import React, {useEffect, useRef, useState} from "react";
import Button from "../../../../../../components/button/button.jsx";
import ModalAddress from "../../../../../../components/modal/modal-address.jsx";
import InputSwitch from "../../../../../../components/input/input-switch.jsx";
import SelectItemModal from "./select-item-modal.jsx";
import {
  createBasicSetup,
  lanesCapturePlace,
  lanesLane,
  lanesRoute,
  regionTypesArr
} from "../../../utils/lanes-form-utils.js";
import {columnDefsCapturePlace, columnDefsRoute} from "./lanes-form-ui.jsx";
import FormField from "../../../../../../components/react-hook-form/form-field.jsx";
import {useFormContext} from "react-hook-form";
import RouteImageLanes from "./route-image-lanes.jsx";
import {clearRequiredFieldError} from "../../../../../../utils/project-utils.js";

const PclRouteForm = ({dataInfo}) => {
  const [showMap, setShowMap] = useState(false);
  const { watch , setValue, getValues} = useFormContext();

  const isNewCapturePlace = watch("isNewCapturePlace");
  const isNewRoute = watch("isNewRoute");
  const capturePlace = watch("capturePlace");
  const mobile = watch("capturePlace.mobile");
  const capturePlaceSnapshot = watch("capturePlaceSnapshot");
  const routeSnapshot = watch("routeSnapshot");
  const route = watch("route");
  const hasCapturePlaceSelection = Boolean(isNewCapturePlace || capturePlace?.code || capturePlaceSnapshot);
  const hasRouteSelection = Boolean(mobile || isNewRoute || route?.code || routeSnapshot);
  const capturePlaceRequiredRef = useRef(null);
  const routeRequiredRef = useRef(null);

  useEffect(() => {
    if (hasCapturePlaceSelection) clearRequiredFieldError(capturePlaceRequiredRef.current);
  }, [hasCapturePlaceSelection]);

  useEffect(() => {
    if (hasRouteSelection) clearRequiredFieldError(routeRequiredRef.current);
  }, [hasRouteSelection]);

  const updateLatLng = (val) => {
    setValue("capturePlace.latitude", val?.lat?.())
    setValue("capturePlace.longitude", val?.lng?.())
  };

  const handleRouteImageState = (updateFunction) => {
    const newRoute = updateFunction(route);
    setValue("route", newRoute, { shouldDirty: true });
  };



  return(
    <div className="flex flex-col gap-2">
      <Card>
        <Card.Header><Card.Title>Ponto de coleta</Card.Title></Card.Header>
        <Card.Body>
          <SentryRow>
            <div className="col-span-12 flex gap-4">
              <FormField
                name="isNewCapturePlace"
                customRender={field => (
                  <InputSwitch label="Novo ponto"
                               id="newPointForm"
                               checked={field.value}
                               onChange={() => {
                                 const newValue = !field.value
                                 field.onChange(newValue);
                                 if(newValue) {
                                   setValue("capturePlace", lanesCapturePlace);
                                   return;
                                 }
                                 if(!newValue && capturePlaceSnapshot) {
                                   setValue("capturePlace", capturePlaceSnapshot);
                                 }
                               }}
                  />
                )}
              />
              <FormField
                name="capturePlace.mobile"
                customRender={field => (
                  <InputSwitch label="Móvel"
                               id="laneMobileForm"
                               checked={field.value}
                               onChange={() => {
                                 const newValue = !field.value
                                 setValue('lane', lanesLane, {shouldDirty: true});
                                 setValue("smartcaptureDriver.back", createBasicSetup());
                                 setValue("smartcaptureDriver.forward", createBasicSetup());
                                 const capturePlace = {...getValues("capturePlace"), address: "", number: "", neighborhood: "", city: "", latitude: "", longitude: ""};
                                 setValue("capturePlace", capturePlace);
                                 if(newValue) {
                                   setValue("route", lanesRoute)
                                 } else {
                                   setValue("route", routeSnapshot)
                                 }
                                 field.onChange(newValue);
                               }}
                               disabled={!isNewCapturePlace || capturePlace?.code}
                  />
                )}
              />
              <div
                ref={capturePlaceRequiredRef}
                className="relative w-fit border border-transparent rounded-md transition-[border-color,border-width] duration-150 ease-out"
                data-required-field="true"
                data-required-has-value={hasCapturePlaceSelection ? "true" : "false"}
                data-required-focus="true"
                tabIndex={-1}
                aria-label="Ponto de coleta"
              >
                <SelectItemModal isDisabled={isNewCapturePlace}
                                 type="capturePlace"
                                 columnDefs={columnDefsCapturePlace}
                />
              </div>
            </div>
            <FormField
              name="capturePlace.description"
              as={InputForm}
              id="capturePlaceDescriptionForm"
              label="Nome *"
              classNameWrapper="col-span-8"
              disabled={!(dataInfo?.capturePlace?.code || isNewCapturePlace || capturePlaceSnapshot)}
            />
           <FormField
            name="capturePlace.group"
            customRender={field => (
              <InputForm
                id="laneGroupForm"
                label="Grupo de pontos de coleta (SentryView)"
                value={field.value}
                onChange={({target}) => field.onChange(target?.value)}
                classNameWrapper="col-span-4"
                disabled={!(dataInfo?.capturePlace?.code || isNewCapturePlace || capturePlaceSnapshot)}
              />
            )}
           />
          <FormField
            name="capturePlace.zipcode"
            customRender={field => (
              <InputForm
                id="laneZipcodeForm"
                label="CEP"
                value={field.value}
                onChange={({target}) => field.onChange(target?.value)}
                mask={MaskDefault.cep}
                classNameWrapper="col-span-4"
                disabled={!(dataInfo?.capturePlace?.code || isNewCapturePlace || capturePlaceSnapshot)}
              />
            )}
          />
            <FormField
              name="capturePlace.address"
              customRender={field => (
                <SelectComponent
                  loadOptions={getStreets}
                  value={optionsUtils.getValue(field.value)}
                  isAsync={true}
                  label={"Logradouro *"}
                  onChange={selected => field.onChange(selected?.value)}
                  cacheOptions
                  defaultOptions={[]}
                  classNameWrapper="col-span-6"
                  isDisabled={mobile || !(dataInfo?.capturePlace?.code || isNewCapturePlace || capturePlaceSnapshot)}
                />
              )}
            />
            <FormField
              name="capturePlace.number"
              customRender={field => (
                <InputForm
                  id="laneNumber"
                  label="Número"
                  value={field.value}
                  onChange={({target}) => field.onChange(target?.value)}
                  classNameWrapper="col-span-2"
                  disabled={mobile || !(dataInfo?.capturePlace?.code || isNewCapturePlace || capturePlaceSnapshot)}
                />
              )}
            />
            <FormField
              name="capturePlace.neighborhood"
              customRender={field => (
                <SelectComponent
                  loadOptions={getNeighborhoods}
                  value={optionsUtils.getValue(field.value)}
                  isAsync={true}
                  label={"Bairro"}
                  onChange={selected => field.onChange(selected?.value)}
                  cacheOptions
                  defaultOptions={[]}
                  classNameWrapper="col-span-6"
                  isDisabled={mobile || !(dataInfo?.capturePlace?.code || isNewCapturePlace || capturePlaceSnapshot)}
                />
              )}
            />
           <FormField
            name="capturePlace.city"
            customRender={field => (
              <SelectComponent
                loadOptions={getCities}
                value={optionsUtils.getValue(field.value)}
                isAsync={true}
                label={"Município *"}
                onChange={selected => field.onChange(selected?.value)}
                cacheOptions
                defaultOptions={[]}
                classNameWrapper="col-span-6"
                isDisabled={mobile || !(dataInfo?.capturePlace?.code || isNewCapturePlace || capturePlaceSnapshot)}
              />
            )}
           />
           <FormField
             name="capturePlace.latitude"
             customRender={field => (
               <InputForm
                 id="laneLat"
                 label="Latitude *"
                 value={field.value}
                 onChange={({target}) => field.onChange(target?.value)}
                 classNameWrapper="col-span-5"
                 disabled={mobile || !(dataInfo?.capturePlace?.code || isNewCapturePlace || capturePlaceSnapshot)}
               />
             )}
           />
           <FormField
             name="capturePlace.longitude"
             customRender={field => (
               <InputForm
                 id="laneLng"
                 label="Longitude *"
                 value={field.value}
                 onChange={({target}) => field.onChange(target?.value)}
                 classNameWrapper="col-span-5"
                 disabled={mobile || !(dataInfo?.capturePlace?.code || isNewCapturePlace || capturePlaceSnapshot)}
               />
             )}
           />
            <div className="col-span-2">
              <Button className="w-full!" type="button" onClick={() => setShowMap(true)}
                      disabled={mobile || !(dataInfo?.capturePlace?.code || isNewCapturePlace || capturePlaceSnapshot)}>Mapa</Button>
            </div>
            <ModalAddress
              open={showMap}
              setOpen={setShowMap}
              address={capturePlace}
              changeLocation={(value) => updateLatLng(value)}
            />
          </SentryRow>
        </Card.Body>
      </Card>
      <Card>
        <Card.Header><Card.Title>Sentido</Card.Title></Card.Header>
        <Card.Body>
          <SentryRow>
            <div className="col-span-12 grid grid-cols-12 gap-4">
              <div className="flex flex-col gap-4 col-span-8">
                <div className="flex gap-4">
                 <FormField
                  name="isNewRoute"
                  customRender={field => (
                    <InputSwitch
                      id="newRouteForm"
                      label="Novo sentido"
                      onChange={() => {
                        const newValue = !field.value
                        field.onChange(newValue)
                        if(newValue) {
                          setValue("route", lanesRoute);
                          return;
                        }
                        if(!newValue && route) {
                          setValue("route", routeSnapshot);
                        }
                      }}
                      checked={field.value}
                      disabled={mobile}
                    />
                  )}
                 />
                  <div
                    ref={routeRequiredRef}
                    className="relative w-fit border border-transparent rounded-md transition-[border-color,border-width] duration-150 ease-out"
                    data-required-field="true"
                    data-required-has-value={hasRouteSelection ? "true" : "false"}
                    data-required-focus="true"
                    tabIndex={-1}
                    aria-label="Sentido"
                  >
                    <SelectItemModal isDisabled={isNewRoute || mobile}
                                     type="route"
                                     columnDefs={columnDefsRoute}
                    />
                  </div>
                </div>
                <FormField
                  name="route.description"
                  customRender={field => (
                    <InputForm
                      id="routeDescriptionForm"
                      label="Nome *"
                      value={field.value}
                      onChange={({target}) => field.onChange(target?.value)}
                      classNameWrapper="flex"
                      disabled={mobile || !(dataInfo?.route?.code ||isNewRoute || routeSnapshot)}
                    />
                  )}
                />
                <FormField
                  name="route.regionType"
                  customRender={field => (
                    <SelectComponent
                      instanceId="routeRegionTypeForm"
                      id="routeRegionTypeForm"
                      label="Tipo *"
                      value={field.value}
                      onChange={selected => field.onChange(selected?.value)}
                      options={regionTypesArr}
                      isDisabled={mobile || !(dataInfo?.route?.code ||isNewRoute || routeSnapshot)}
                    />
                  )}
                />
              </div>
              <div className=" col-span-4">
                <RouteImageLanes state={route} setState={handleRouteImageState} isDisabled={mobile || !(dataInfo?.route?.code || isNewRoute || routeSnapshot)}/>
              </div>
            </div>
          </SentryRow>
        </Card.Body>
      </Card>
    </div>
  )
}

export default PclRouteForm;